import { catchError } from "../../../Actions/Error.action";
import { get } from "../../../Services/http";

export const CONTACT_PAGE_RECEIVE = "CONTACT_PAGE_RECEIVE";
export const CONTACT_PAGE_ERROR = 'CONTACT_PAGE_ERROR';
export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_SELECTED_COUNTRIES = 'SET_SELECTED_COUNTRIES';
export const SET_ALL_COUNTRIES = 'SET_ALL_COUNTRIES';
export const REMOVE_SELECTED_COUNTRIES = 'REMOVE_SELECTED_COUNTRIES';
export const SET_ZOOM_LEVEL = 'SET_ZOOM_LEVEL';
export const SET_CENTER = 'SET_CENTER';
export const SET_IS_CLICKED_MARKER = "SET_IS_CLICKED_MARKER";

export const fetchContactPageData = (id) => (dispatch) => {
    const html = document.querySelector("html");
    const culture = html.getAttribute("lang");
    return get('/api/contactPage/' + id + '/' + culture)
        .then(response => {
            return response.json();
        })
        .then(result => {
            dispatch(receive(result));
        })
        .catch(ex => {
            dispatch(catchError(ex, error => setError(error)));
        });
}


export const setError = error => ({
    type: CONTACT_PAGE_ERROR,
    payload: {
        error,
    },
});

export const receive = result => ({
    type: CONTACT_PAGE_RECEIVE,
    payload: result
})

export const setUserLocation = (location) => ({
    type: SET_USER_LOCATION,
    payload: location
});

export const setSelectedCountries = (countries) => ({
    type: SET_SELECTED_COUNTRIES,
    payload: countries
});

export const setAllCountries = (countries) => ({
    type: SET_ALL_COUNTRIES,
    payload: countries
});

export const removeSelectedCountries = (countryName) => ({
    type: REMOVE_SELECTED_COUNTRIES,
    payload: countryName.toLowerCase(),
});

export const setZoomLevel = (zoomLevel) => ({
    type: SET_ZOOM_LEVEL,
    payload: zoomLevel
});

export const setCenter = (center) => ({
    type: SET_CENTER,
    payload: center
});

export const setIsClickedMarker = (isClickedMarker) => ({
    type: SET_IS_CLICKED_MARKER,
    payload: isClickedMarker
});